import React from 'react';

function OurTeamPage() {
    return <div>Our Team Page</div>;
}

export default OurTeamPage;
